import {
  DELETE_PATIENT_UPLOADED_FILES,
  RESET_PATIENT_DATA,
  SET_PATIENT_DATA,
  SET_PATIENT_DATA_CURRENT_CYCLE,
  SET_PATIENT_UPLOADED_FILES,
  SET_SELECTED_PATIENT_DATA,
} from '../actions';
import { calculateAge } from '../screens/Registrationform/helpers/calculateAge';
import dayjs from 'dayjs';

export const currentCycleIntitialState = {
  id: null,
  cycleid: null,
  patientId: null,
  createdAt: '',
  fetSheet: {
    tableData: [
      {
        date: '',
        day: '',
        e2: '',
        p4: '',
        endometrialThickness: '',
        medicine1: '',
        dose1: '',
        medicine2: '',
        dose2: '',
        medicine3: '',
        dose3: '',
        comments: '',
      },
    ],
    typesOfET: '',
    procedureDate: '',
    procedureTime: '',
    triggerDate: '',
    triggerTime: '',
  },
  fmsData: {
    opuComment: '',
    opuSign: '',
    opuSheetDate: '',
    treatmentPlanForm: {
      lmp: '',
      amh: '',
      diagnosis: '',
      plan: '',
      customTreatmentPlan: 'NC',
      customTreatmentPlanOther: '',
      treatmentPlanDate: '',
    },
    tableData: [
      {
        date: '',
        day: '',
        e2: '',
        p4: '',
        endometrialThickness: '',
        medicineRow: [{ medicine: '', dose: '' }],
        rightOvary: '',
        dopplerRight: '',
        leftOvary: '',
        dopplerLeft: '',
        comments: '',
      },
    ],
    stimulationProtocol: [
      { name: 'Agonist', label: 'AGONIST', checked: false },
      { name: 'Antagonist', label: 'ANTAGONIST', checked: false },
      { name: 'Other', label: 'OTHER', checked: false },
    ],
    stimulationProtocolOther: '',
    triggerTable: [
      {
        medicine: '',
        dose: '',
      },
    ],
    procedureDate: '',
    procedureTime: '',
    triggerDate: '',
    triggerTime: '',
    comments: '',
  },
};
const initialState = {
  selectedCycleId: null,
  selectedPatientData: {
    isFetched: false,
    patient: {
      firstName: '',
      lastName: '',
      age: '',
      mpi: '',
      bmi: '',
      updatedAt: null,
      phone: null,
      upid: null,
      company: {
        occupation: '',
      },
      referral: {
        referringPhysician: '',
      },
      partner: {
        firstName: '',
        lastName: '',
        dob: '',
        occupation: '',
        age: '',
        mpi: '',
        bmi: '',
      },
      histories: {
        id: null,
        updatedAt: null,
      },
      examinations: {
        updatedAt: null,
        id: null,
      },
      treatmentPlans: {
        id: null,
        updatedAt: null,
      },
    },
    patientFiles: [],
  },
  selectedPatienId: null,
  patientDetails: {
    wifeName: '',
    wifeAge: '',
    wifeOccupation: '',
    patientMPI: '',
    patientBMI: '',
    husbandName: '',
    husbandAge: '',
    husbandOccupation: '',
    partnerMPI: '',
    partnerBMI: '',
    address: '',
    phone: '',
    referredBy: '',
    registrationDate: null,
  },
  infertilityDetails: {
    infertilityType: '',
    causeOfInfertilityType: [
      { name: 'POR', label: 'POR', checked: false },
      { name: 'PCO', label: 'PCO', checked: false },
      { name: '>Age', label: '>Age', checked: false },
      { name: '<AMH', label: '<AMH', checked: false },
      { name: 'Anovulation', label: 'Anovulation', checked: false },
      { name: 'Tubal block', label: 'Tubal block', checked: false },
      { name: 'Endometriosis', label: 'Endometriosis', checked: false },
      { name: 'Others', label: 'Others', checked: false },
    ],
    causeOfInfertilityTypeOther: '',
    infertilityComment: '',
  },
  patientHistory: {
    durationOfMarriage: '',
    durationOfPregnancyAttempts: '',
    mensurationalHistory: {
      cycleDurationAverage: '',
      LMP: '',
      durationOfFlow: '',
      contraception: '',
      dysmenorrohea: '',
      dysmenorroheaType: '',
    },
    sexualHistory: {
      complaints: [
        { name: 'Impotence', label: 'Impotence', checked: false },
        { name: 'Aparenuia', label: 'Aparenuia', checked: false },
        {
          name: 'Premature Ejaculation',
          label: 'Premature Ejaculation',
          checked: false,
        },
        {
          name: 'Retrograde Ejaculation',
          label: 'Retrograde Ejaculation',
          checked: false,
        },
        { name: 'Vaginismus', label: 'Vaginismus', checked: false },
        { name: 'Dysparenuia', label: 'Dysparenuia', checked: false },
        { name: 'Other', label: 'Other', checked: false },
      ],
      complaintsOther: '',
    },
    previousObstetricHistory: {
      parity: false,
      abortions: false,
      ectopic: false,
      liveBirth: false,
      type: [
        { name: 'parity', label: 'Parity', checked: false },
        { name: 'abortions', label: 'Abortions', checked: false },
        { name: 'ectopic', label: 'Ectopic', checked: false },
        { name: 'liveBirth', label: 'Live Birth', checked: false },
      ],
      pregnancy: [
        { id: 1, year: '', conception: 'IVF', outcome: '', delivery: '' },
        { id: 2, year: '', conception: 'Sp', outcome: '', delivery: '' },
        { id: 3, year: '', conception: 'IUI', outcome: '', delivery: '' },
      ],
    },
    previousSurgeries: '',
    pastMedicalHistory: [
      { name: 'Allergies', label: 'Allergies', checked: false },
      { name: 'DM', label: 'DM', checked: false },
      { name: 'HTn', label: 'HTn', checked: false },
      { name: 'Thyroid', label: 'Thyroid', checked: false },
      { name: 'Asthma', label: 'Asthma', checked: false },
      { name: 'Tuberculosis', label: 'Tuberculosis', checked: false },
      { name: 'Other', label: 'Other', checked: false },
    ],
    pastMedicalHistoryOther: '',
    familyHistory: [
      { name: 'Diabetes', label: 'Diabetes', checked: false },
      { name: 'Hypertension', label: 'Hypertension', checked: false },
      { name: 'Cancer', label: 'Cancer', checked: false },
      { name: 'Other', label: 'Other', checked: false },
    ],
    familyHistoryOther: '',
    generalHistory: [
      { name: 'Smoking', label: 'Smoking', checked: false },
      { name: 'Alcohol', label: 'Alcohol', checked: false },
      { name: 'Exercise', label: 'Exercise', checked: false },
      {
        name: 'Recreational drugs',
        label: 'Recreational drugs',
        checked: false,
      },
      { name: 'Other', label: 'Other', checked: false },
    ],
    generalHistoryOther: '',
    treatmentHistory: {
      OI: { name: 'OI', noOfAttempts: '', date: '', comments: '' },
      IUI: { name: 'IUI', noOfAttempts: '', date: '', comments: '' },
      IVF: { name: 'IVF', noOfAttempts: '', date: '', comments: '' },
    },
    previousIVF: {
      noOfCycles: '',
      attempt1: {
        date: '',
        place: '',
        protocol: '',
        typeOfGonadotropin: '',
        totalStimulationDays: '',
        totalDose: '',
        noOfEggs: '',
        noOfEmbryos: '',
        noTransferred: '',
        outcome: '',
        frozen: '',
        comments: '',
      },
      attempt2: {
        date: '',
        place: '',
        protocol: '',
        typeOfGonadotropin: '',
        totalStimulationDays: '',
        totalDose: '',
        noOfEggs: '',
        noOfEmbryos: '',
        noTransferred: '',
        outcome: '',
        frozen: '',
        comments: '',
      },
      attempt3: {
        date: '',
        place: '',
        protocol: '',
        typeOfGonadotropin: '',
        totalStimulationDays: '',
        totalDose: '',
        noOfEggs: '',
        noOfEmbryos: '',
        noTransferred: '',
        outcome: '',
        frozen: '',
        comments: '',
      },
    },
  },
  examinationOfFemalePartner: {
    partnerWeight: '',
    partnerHeight: '',
    partnerBMI: '',
    partnerBP: '',
    partnerPallor: '',
    partnerThyroid: '',
    partnerGalactorrhoea: '',
    partnerHirusitism: '',
    partnerAbdominalExamination: '',
    partnerSpeculumExamination: '',
    partnerVaginalExamination: '',
  },
  investigationOfFemalePartner: {
    partnerInvestigationHBDate: '',
    partnerInvestigationDate: '',
    partnerAMH: '',
    partnerFSH: '',
    partnerLH: '',
    partnerPRL: '',
    partnerTSH: '',
    partnerE2: '',
    partnerHB: '',
    partnerRBS: '',
    partnerHIV: '',
    partnerHCV: '',
    partnerVDRL: '',
    partnerHBSAG: '',
    partnerKaryotyping: '',
    partnerTBBactec: '',
    partnerTBPCR: '',
    partnerBloodGroup: '',
    partnerHSBDate: '',
    partnerUSG: '',
    partnerUSGDate: '',
    partnerUterus: '',
    partnerET: '',
    partnerRightOvary: '',
    partnerLeftOvary: '',
    comments: '',
  },
  evalutionOfMalePartner: {
    recentIssues: [
      { name: 'Fever', label: 'Fever', checked: false },
      { name: 'Trauma', label: 'Trauma', checked: false },
      {
        name: 'Undescended Testis',
        label: 'Undescended Testis',
        checked: false,
      },
      { name: 'Torsion', label: 'Torsion', checked: false },
      { name: 'Mumps', label: 'Mumps', checked: false },
      { name: 'Other', label: 'Other', checked: false },
    ],
    recentIssuesOther: '',
    medicalHistory: [
      { name: 'Allergies', label: 'Allergies', checked: false },
      { name: 'DM', label: 'DM', checked: false },
      { name: 'HTn', label: 'HTn', checked: false },
      { name: 'Thyroid', label: 'Thyroid', checked: false },
      { name: 'Asthma', label: 'Asthma', checked: false },
      { name: 'Tuberculosis', label: 'Tuberculosis', checked: false },
      { name: 'Other', label: 'Other', checked: false },
    ],
    medicalHistoryOther: '',
    personalHistory: [
      { name: 'Smoking', label: 'Smoking', checked: false },
      { name: 'Alcohol', label: 'Alcohol', checked: false },
      { name: 'Exercise', label: 'Exercise', checked: false },
      {
        name: 'Recreational drugs',
        label: 'Recreational drugs',
        checked: false,
      },
      { name: 'Other', label: 'Other', checked: false },
    ],
    personalHistoryOther: '',
    surgeries: [
      { name: 'Hernia', label: 'Hernia', checked: false },
      { name: 'Hydrocele', label: 'Hydrocele', checked: false },
      { name: 'Orchidopexy', label: 'Orchidopexy', checked: false },
      { name: 'Orchidectomy', label: 'Orchidectomy', checked: false },
      { name: 'Other', label: 'Other', checked: false },
    ],
    surgeriesOther: '',
  },
  examinationOfMalePartner: {
    partnerWeight: '',
    partnerHeight: '',
    partnerBMI: '',
    sourceOfSperm: 'Ejaculate',
    sourceOfSpermOther: '',
    tableData: [
      {
        semenAnalysisDate: null,
        volume: '',
        countMml: '',
        aprog: '',
        srog: '',
        np: '',
        nm: '',
        morphology: '',
        semenCulture: '',
        interpretation: '',
      },
    ],
    FSH: '',
    PRL: '',
    RBS: '',
    TRUS: '',
    scrotalScan: '',
    comments: '',
    TesticularBiopsy: '',
    SalientFeatures: '',
    Karotyping: '',
    HIV: '',
    HCV: '',
    HBsAG: '',
    VDRL: '',
    BldGrp: '',
    motilityNM: '',
    Hb: '',
    Testosterone: '',
    T3T4TSH: '',
    LH: '',
    comments: '',
  },
  treatmentPlan: {
    treatmentPlan: 'Ovulation induction',
    treatmentPlanOther: '',
    sourceOfGamete: 'Self',
    female: 'Self Oocyte',
    male: 'Self Sperm',
    sourceOfSperm: 'Ejaculate',
    sourceOfSpermOther: '',
    embryoGeneticAnalysisPGTA: '',
    embryoGeneticAnalysisPGTAChecked: false,
    embryoGeneticAnalysisPGTMChecked: false,
    embryoGeneticAnalysisPGTM: '',
    embryoTransferDetails: 'Fresh ET',
  },

  currentCycle: JSON.parse(JSON.stringify(currentCycleIntitialState)),
  patientCycles: [],
  uploadedFiles: [],
};

const updateNestedState = (state, keyPath, value) => {
  try {
    if (!keyPath) {
      console.error('Invalid keyPath:', keyPath);
      return state; // Return original state if keyPath is invalid
    }
    const keys = keyPath.split('.');
    const newState = { ...state };

    let current = newState;

    for (let i = 0; i < keys.length - 1; i++) {
      const key = keys[i];

      if (!key || !(key in current)) {
        console.error('Invalid key in path:', key);
        return state; // If any key is invalid, return the original state
      }

      current = current[key];
    }

    const finalKey = keys[keys.length - 1];

    if (finalKey) {
      current[finalKey] = value; // Only update if the final key is valid
    } else {
      console.error('Empty key at the end of the keyPath');
    }

    return newState;
  } catch (err) {
    console.error(err, keyPath, value);
    return state;
  }
};

const clinicalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PATIENT_DATA:
      return updateNestedState(
        state,
        action.payload.keyPath,
        action.payload.value,
      );
    case SET_SELECTED_PATIENT_DATA:
      let parsedDate = dayjs(action.payload.patient.partner.dob);
      let husbandAge = '';
      if (!parsedDate.isValid()) {
        husbandAge = '';
      } else {
        husbandAge = calculateAge(parsedDate);
      }
      return {
        ...state,
        selectedPatientData: { ...action.payload, isFetched: true },
        patientDetails: {
          ...state.patientDetails,
          wifeName:
            action.payload.patient.firstName +
            ' ' +
            action.payload.patient.lastName,
          wifeOccupation: action.payload.patient.company.occupation,
          wifeAge: action.payload.patient.age,
          husbandName:
            action.payload.patient.partner.firstName +
            ' ' +
            action.payload.patient.partner.lastName,
          husbandOccupation: action.payload.patient.partner.occupation,
          husbandAge,
          patientBMI: action.payload.patient.patientBMI,
          patientMPI: action.payload.patient.patientMPI,
          partnerBMI: action.payload.patient.partnerBMI,
          partnerMPI: action.payload.patient.partnerMPI,
          registrationDate: action.payload.patient.createdAt,
        },
        infertilityDetails: action.payload.patient.infertilityDetails.id
          ? action.payload.patient.infertilityDetails
          : initialState.infertilityDetails,
        patientHistory: action.payload.patient.histories.history
          ? action.payload.patient.histories.history
          : initialState.patientHistory,
        treatmentPlan: action.payload.patient.treatmentPlans.treatmentPlan
          ? action.payload.patient.treatmentPlans.treatmentPlan
          : initialState.treatmentPlan,
        examinationOfFemalePartner: action.payload.patient.examinations
          .examinationOfFemalePartner
          ? action.payload.patient.examinations.examinationOfFemalePartner
          : initialState.examinationOfFemalePartner,
        investigationOfFemalePartner: action.payload.patient.examinations
          .investigationOfFemalePartner
          ? action.payload.patient.examinations.investigationOfFemalePartner
          : initialState.investigationOfFemalePartner,
        evalutionOfMalePartner: action.payload.patient.examinations
          .evalutionOfMalePartner
          ? action.payload.patient.examinations.evalutionOfMalePartner
          : initialState.evalutionOfMalePartner,
        examinationOfMalePartner: action.payload.patient.examinations
          .examinationOfMalePartner
          ? action.payload.patient.examinations.examinationOfMalePartner
          : initialState.examinationOfMalePartner,
        patientCycles: action.payload.patient.patientCycles
          ? action.payload.patient.patientCycles
          : initialState.patientCycles,
        currentCycle: action.payload.patient.currentCycle
          ? action.payload.patient.currentCycle
          : initialState.currentCycle,
        uploadedFiles: action.payload.patientFiles,
      };

    case SET_PATIENT_DATA_CURRENT_CYCLE:
      return {
        ...state,
        currentCycle: action.payload,
      };
    case RESET_PATIENT_DATA:
      return initialState;

    case SET_PATIENT_UPLOADED_FILES:
      const newUploadedFiles = [...state.uploadedFiles];
      newUploadedFiles.push(action.payload);
      return {
        ...state,
        uploadedFiles: newUploadedFiles,
      };
    case DELETE_PATIENT_UPLOADED_FILES:
      const newFiles = state.uploadedFiles.filter(
        (uploadedFile) => uploadedFile?.file?.fileId !== action.payload.fileId,
      );
      return {
        ...state,
        uploadedFiles: newFiles,
      };
    default:
      return state;
  }
};

export default clinicalReducer;
